import { withPending, withRejected, withFulFilled } from './commons';
import { CLEAR_ANNOTATIONS_ERRORS, FETCH_ANNOTATIONS, SAVE_ANNOTATIONS, annotationStrategyMap } from '../actions/annotations';


/**
 * Reducer para tratar actions que lidam com anotacoes
 * a estrutura da store fica:
 * const state = {
 *      ...,
 *      annotations: {
 *          [strategy]: {
 *              [resultIdentifier]: {
 *                  error : {
 *                      [operation] : {}
 *                  }
 *                  running: boolean
 *                  value: {}
 *              }
 *          }
 *      }
 *
 * }
 */

const INITIAL_STATE = (() => {
  const state = {};
  const keys = Object.keys(annotationStrategyMap).map((key) => annotationStrategyMap[key]);
  keys.forEach((key) => state[key] = {});
  return state;
})();

function defaultRequestHandlerWithPending(state, action) {
  const { resultType, resultIdentifier } = action.meta;
  const newState = { ...state };
  if (!newState[resultType]) {
    newState[resultType] = {};
  }
  if (!newState[resultType][resultIdentifier]) {
    newState[resultType][resultIdentifier] = {
      error: null,
      running: true,
      value: null,
    };
  } else {
    newState[resultType][resultIdentifier].running = true;
  }
  newState[resultType][resultIdentifier] = { ...newState[resultType][resultIdentifier] };
  return newState;
}

function defaultRequestHandlerWithFullFilled(state, action) {
  const { resultType, resultIdentifier } = action.meta;
  const newState = { ...state };
  newState[resultType][resultIdentifier] = { ...newState[resultType][resultIdentifier] };

  newState[resultType][resultIdentifier] = {
    error: null,
    running: false,
    value: action.payload.data,
  };
  return newState;
}

function defaultRequestHandlerWithRejected(state, action) {
  const { resultType, resultIdentifier, operation } = action.meta;
  const newState = { ...state };
  newState[resultType][resultIdentifier] = { ...newState[resultType][resultIdentifier] };

  newState[resultType][resultIdentifier].running = false;
  newState[resultType][resultIdentifier].error = {};
  newState[resultType][resultIdentifier].error[operation] = action.payload.response;
  return newState;
}

function clearErrors(state, action) {
  const newState = { ...state };
  const { resultType, resultIdentifier } = action.meta;

  newState[resultType][resultIdentifier].error = null;
  return newState;
}

const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  /**
         * Fetch
         */
  case withPending(FETCH_ANNOTATIONS):
    return defaultRequestHandlerWithPending(state, action);
  case withFulFilled(FETCH_ANNOTATIONS):
    return defaultRequestHandlerWithFullFilled(state, action);
  case withRejected(FETCH_ANNOTATIONS):
    return defaultRequestHandlerWithRejected(state, action);

    /**
         * Save
         */
  case withPending(SAVE_ANNOTATIONS):
    return defaultRequestHandlerWithPending(state, action);
  case withFulFilled(SAVE_ANNOTATIONS):
    return defaultRequestHandlerWithFullFilled(state, action);
  case withRejected(SAVE_ANNOTATIONS):
    return defaultRequestHandlerWithRejected(state, action);

  case CLEAR_ANNOTATIONS_ERRORS: return clearErrors(state, action);

  default:
    return state;
  }
};

export default execute;
